import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "value-tooltip",
  templateUrl: "./value-tooltip.component.html",
  styleUrls: ["./value-tooltip.component.scss"],
})
export class ValueTooltipComponent implements OnInit {
  @Input() school;
  @Input() district;
  @Input() column;

  constructor() {}

  ngOnInit() {}

  getColor(goal, upIsGood, value) {
    if (goal === null || goal === "" || value === null || value === "") {
      return "#5E5E5E"; //grey
    }
    if ((upIsGood && value >= goal) || (!upIsGood && value <= goal)) {
      return "#22B79A"; //green
    }
    return "#ED4C3D"; //red
  }
}
